'use strict';

module.exports = {
  STANDARD: 'standard',
  DOMAINS: 'domains',
  ORDER_LEVEL: 'order-level'
};